module.exports = __webpack_public_path__ + "img/ico-point-b.9461fca4.svg";